import React, { useEffect, useState, useContext } from 'react';

import Logo from './Logo'

import { AccountContext } from './auth/Accounts';
import API from '../api';
import { withSnackbar } from "./HOC/Alert";

function Header(props) {
    const [logosrc, setLogoSrc] = useState("")

    const { getSession } = useContext(AccountContext);

    useEffect(() => {
        getSession()
            .then(session => {
                API.get("/org_settings/logo", {
                    headers: { "Authorization": session.idToken.jwtToken },
                    params: { org_name: session.idToken.payload.name }
                })
                    .then(res => {
                        setLogoSrc(res.data)
                    })
                    .catch(() => {})
            })
    }, []);

    return (
        <header className="py-3">
            <Logo src={logosrc} />
        </header>
    )
}

export default withSnackbar(Header);
